import { IntlShape, injectIntl } from 'react-intl';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import WarningCard from 'containers/common/Card/WarningCard';
export interface SuspiciousCardProps {
  intl: IntlShape;
}
const SuspiciousCard: React.FC<SuspiciousCardProps> = props => {
  return <WarningCard message={messages.suspiciousClaim} />;
};
export default injectIntl(SuspiciousCard);
